import axiosClient from './axiosClient';

const serviceRequestService = {
  // public
  create: (payload) => axiosClient.post('/service-requests', payload),

  // admin / approver
  list: (params = {}) => axiosClient.get('/service-requests', { params }),
  update: (id, payload) => axiosClient.patch(`/service-requests/${id}`, payload),
  forward: (id) => axiosClient.post(`/service-requests/${id}/forward`),
};

export default serviceRequestService;
